function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#009471",
  fillRule: "evenodd",
  d: "M18.16 5.519l-4.526 13.575a.3.3 0 01-.555.035l-2.882-6.027L4.17 10.22a.3.3 0 01.035-.555L17.78 5.139a.3.3 0 01.38.38z"
});

function SvgLocationGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgLocationGreen;